"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterModal = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_router_dom_1 = require("react-router-dom");
var TopHeader_1 = __importDefault(require("../AppHeader/TopHeader"));
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../features/languages/languageSlice");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var localization_1 = require("../../helpers/localization");
var classnames_1 = __importDefault(require("classnames"));
var postSlice_1 = require("../../features/post/postSlice");
var useDeviceResize_1 = require("../../hooks/useDeviceResize");
var globalSlice_1 = require("../../features/global/globalSlice");
var Localization_1 = require("../../constants/Localization");
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var RouterModal = function (props) {
    var dispatch = react_redux_1.useDispatch();
    var modalContainer = document.getElementById('router-modal');
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var languageList = react_redux_1.useSelector(languageSlice_1.selectLanguages);
    var currencyList = react_redux_1.useSelector(currencySlice_1.selectCurrencies);
    var currentCurrency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var mobileResize = useDeviceResize_1.useDeviceResize(useDeviceResize_1.MediaQueries.mobile);
    var postData = react_redux_1.useSelector(postSlice_1.selectSinglePost);
    react_1.useEffect(function () {
        dispatch(globalSlice_1.openPostPreview());
        // Adding class to hide secondary scroll on body
        document.body.classList.add('bl_router_modal_opened');
        return function () {
            dispatch(globalSlice_1.closePostPreview());
            dispatch(postSlice_1.clearPostData());
            // Remove class to enable scroll
            document.body.classList.remove('bl_router_modal_opened');
        };
    }, []);
    var closeModal = function () {
        var _a;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.prevURL) {
            history.push(location.state.prevURL);
        }
        else if (location.pathname.includes('announcements') ||
            location.pathname.includes('wishlist')) {
            history.push("/" + [1, 2]
                .map(function (index) { return location.pathname.split('/')[index]; })
                .join('/'));
        }
        else if (sessionStorage.getItem('prevURL')) {
            changeLanguage();
        }
        else {
            history.push(props.backUrl + Localization_1.LocalizationSettings.defaultState);
        }
        isFunction_1.default(props.setIsPostCardClicked) &&
            props.setIsPostCardClicked(false);
    };
    var languageChangeHandler = function (language) {
        localization_1.handleChangeSPVLanguage(language, postData.id, postData.slug);
    };
    var changeLanguage = function () {
        var _a;
        var prevURL = JSON.parse((_a = sessionStorage.getItem('prevURL')) !== null && _a !== void 0 ? _a : '');
        if (Localization_1.SearchPagePrefix[currentLanguage][prevURL.pathname.split('/')[1]] == prevURL.pathname.split('/')[1]) {
            history.push("/" + prevURL.pathname.split('/')[1] + prevURL.search);
        }
        else if (Localization_1.PagePrefixTranslations["" + currentLanguage][prevURL.pathname.split('/')[1]] !== prevURL.pathname.split('/')[1]) {
            history.push("/" + Localization_1.PagePrefixTranslations["" + currentLanguage][prevURL.pathname.split('/')[1]] + prevURL.search);
        }
    };
    var currencyChangeHandler = function (value) {
        dispatch(currencySlice_1.setCurrency(value));
    };
    if (modalContainer) {
        return react_dom_1.createPortal(react_1.default.createElement("div", { className: styles_module_scss_1.default.app_modal },
            !mobileResize && (react_1.default.createElement("div", { className: classnames_1.default('app-header default_header', "lang-" + currentLanguage, styles_module_scss_1.default.modal_top_header) },
                react_1.default.createElement(TopHeader_1.default, { currencyList: currencyList, currentCurrency: currentCurrency, currentLanguage: currentLanguage, languageList: languageList, isAnnouncementPage: false, languageChangeHandler: languageChangeHandler, currencyChangeHandler: currencyChangeHandler }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_modal_container },
                react_1.default.createElement("div", { onClick: closeModal, className: "bl_modal_backdrop" }),
                react_1.default.createElement("div", { className: "bl_modal_root" },
                    react_1.default.createElement("span", { onClick: closeModal, className: "close" },
                        react_1.default.createElement("i", { className: "icon-close" })),
                    react_1.default.createElement("div", { className: "bl_modal_content" }, props.children)))), modalContainer);
    }
    else {
        console.info("Modal Container doesn't exist width id 'router-modal'");
        return react_1.default.createElement(react_1.Fragment, null);
    }
};
exports.RouterModal = RouterModal;
